<template>
  <div>
    <ToolbarAuth />
    <div v-if="saving">
      <saving />
    </div>
    <div class="mt-15 ml-15 mr-15">
      <v-card class="mb-15">
        <v-row no-gutters>
          <v-col cols="12">
            <h3 class="primary--text ma-8">Module Voortzetting door medewerkers</h3>
          </v-col>
        </v-row>
        <ValidationObserver ref="obs" v-slot="{ invalid, validate, handleSubmit, errors }">
          <v-form ref="form" class="ml-10 mr-10">
            <v-row no-gutters>
              <v-col cols="12">
                <h3 class="accent--text mb-5">Medewerkers</h3>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <StatementText
                  :text="statement[1].question"
                  :note="statement[1].commentApp"
                  :nr-notes="statement[1].nrNotes"
                  :noteA="statement[1].noteAppFormA"
                  :noteB="statement[1].noteAppFormB"
                  :noteC="statement[1].noteAppFormC"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-3">
              <v-col cols="12">
                <base-radio
                  v-model="question_a"
                  :error-messages="errors"
                  rules="required"
                  v-bind:nrOptions="statement[1].nrOptions"
                  v-bind:optionA="statement[1].optionA"
                  v-bind:optionB="statement[1].optionB"
                  v-bind:optionC="statement[1].optionC"
                  v-bind:optionD="statement[1].optionD"
                />
              </v-col>
            </v-row>
            <div v-if="question_a === 'ke2'">
              <v-row no-gutters class="mt-3">
                <v-col cols="12">
                  <StatementText
                    :text="statement[3].question"
                    :note="statement[3].commentApp"
                    :nr-notes="statement[3].nrNotes"
                    :noteA="statement[3].noteAppFormA"
                    :noteB="statement[3].noteAppFormB"
                    :noteC="statement[3].noteAppFormC"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-3">
                <v-col cols="12">
                  <base-val-area rules="max:500" v-model="text_b" v-bind:label="statement[3].label" />
                </v-col>
              </v-row>
            </div>
            <div v-if="question_a === 'ke1'">
              <v-row no-gutters>
                <v-col cols="12">
                  <StatementText
                    :text="textData[1].text"
                    :note="textData[1].commentApp"
                    :nr-notes="textData[1].nrNotes"
                    :noteA="textData[1].noteAppFormA"
                    :noteB="textData[1].noteAppFormB"
                    :noteC="textData[1].noteAppFormC"
                  />
                </v-col>
              </v-row>

              <v-row no-gutters class="mt-3">
                <v-col cols="12">
                  <StatementText
                    :text="statement[4].question"
                    :note="statement[4].commentApp"
                    :nr-notes="statement[4].nrNotes"
                    :noteA="statement[4].noteAppFormA"
                    :noteB="statement[4].noteAppFormB"
                    :noteC="statement[4].noteAppFormC"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-3">
                <v-col cols="12">
                  <BaseValInput rules="required|max:150" v-model="question_b" v-bind:label="statement[1].label" />
                </v-col>
              </v-row>
              <div v-if="question_b !== null">
                <v-row no-gutters class="mt-3">
                  <v-col cols="12">
                    <StatementText
                      :text="statement[5].question"
                      :note="statement[5].commentApp"
                      :nr-notes="statement[5].nrNotes"
                      :noteA="statement[5].noteAppFormA"
                      :noteB="statement[5].noteAppFormB"
                      :noteC="statement[5].noteAppFormC"
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters class="mt-3">
                  <v-col cols="12">
                    <base-radio
                      v-model="question_c"
                      :error-messages="errors"
                      rules="required"
                      v-bind:nrOptions="statement[6].nrOptions"
                      v-bind:optionA="statement[6].optionA"
                      v-bind:optionB="statement[6].optionB"
                      v-bind:optionC="statement[6].optionC"
                      v-bind:optionD="statement[6].optionD"
                    />
                  </v-col>
                </v-row>
              </div>
              <div v-if="question_c === 'ke1'">
                <v-row no-gutters class="mt-3">
                  <v-col cols="12">
                    <BaseValInput rules="required|max:150" v-model="question_d" v-bind:label="statement[6].label" />
                  </v-col>
                </v-row>
                <v-row no-gutters class="mt-3">
                  <v-col cols="12">
                    <StatementText
                      :text="statement[7].question"
                      :note="statement[7].commentApp"
                      :nr-notes="statement[7].nrNotes"
                      :noteA="statement[7].noteAppFormA"
                      :noteB="statement[7].noteAppFormB"
                      :noteC="statement[7].noteAppFormC"
                    />
                  </v-col>
                </v-row>
                <div v-if="question_d !== null">
                  <v-row no-gutters class="mt-3">
                    <v-col cols="12">
                      <base-radio
                        v-model="question_e"
                        :error-messages="errors"
                        rules="required"
                        v-bind:nrOptions="statement[7].nrOptions"
                        v-bind:optionA="statement[7].optionA"
                        v-bind:optionB="statement[7].optionB"
                        v-bind:optionC="statement[7].optionC"
                        v-bind:optionD="statement[7].optionD"
                      />
                    </v-col>
                  </v-row>
                </div>
                <div v-if="question_e === 'ke1'">
                  <v-row no-gutters class="mt-3">
                    <v-col cols="12">
                      <BaseValInput rules="required|max:150" v-model="question_f" v-bind:label="statement[8].label" />
                    </v-col>
                  </v-row>
                </div>
              </div>
              <v-row no-gutters>
                <v-col cols="12">
                  <StatementText
                    :text="textData[2].text"
                    :note="textData[2].commentApp"
                    :nr-notes="textData[2].nrNotes"
                    :noteA="textData[2].noteAppFormA"
                    :noteB="textData[2].noteAppFormB"
                    :noteC="textData[2].noteAppFormC"
                  />
                </v-col>
              </v-row>
              <v-divider class="mt-5" />
              <v-row no-gutters>
                <v-col cols="12">
                  <h3 class="accent--text mb-5 mt-5">Afspraken</h3>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-3">
                <v-col cols="12">
                  <StatementText
                    :text="statement[9].question"
                    :note="statement[9].commentApp"
                    :nr-notes="statement[9].nrNotes"
                    :noteA="statement[9].noteAppFormA"
                    :noteB="statement[9].noteAppFormB"
                    :noteC="statement[9].noteAppFormC"
                  />
                </v-col>
              </v-row>

              <v-row no-gutters class="mt-3">
                <v-col cols="12">
                  <base-radio
                    v-model="question_g"
                    :error-messages="errors"
                    rules="required"
                    v-bind:nrOptions="statement[9].nrOptions"
                    v-bind:optionA="statement[9].optionA"
                    v-bind:optionB="statement[9].optionB"
                    v-bind:optionC="statement[9].optionC"
                    v-bind:optionD="statement[9].optionD"
                  />
                </v-col>
              </v-row>
              <div v-if="question_g === 'ke1'">
                <v-row no-gutters>
                  <v-col cols="12">
                    <StatementText
                      :text="textData[3].text"
                      :note="textData[3].commentApp"
                      :nr-notes="textData[3].nrNotes"
                      :noteA="textData[3].noteAppFormA"
                      :noteB="textData[3].noteAppFormB"
                      :noteC="textData[3].noteAppFormC"
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters class="mt-3">
                  <v-col cols="12">
                    <base-val-area rules="max:500" v-model="text_c" v-bind:label="statement[10].label" />
                  </v-col>
                </v-row>
                <v-row no-gutters class="mt-3">
                  <v-col cols="12">
                    <StatementText
                      :text="statement[11].question"
                      :note="statement[11].commentApp"
                      :nr-notes="statement[11].nrNotes"
                      :noteA="statement[11].noteAppFormA"
                      :noteB="statement[11].noteAppFormB"
                      :noteC="statement[11].noteAppFormC"
                    />
                  </v-col>
                </v-row>

                <v-row no-gutters class="mt-3">
                  <v-col cols="12">
                    <base-radio
                      v-model="question_h"
                      :error-messages="errors"
                      rules="required"
                      v-bind:nrOptions="statement[11].nrOptions"
                      v-bind:optionA="statement[11].optionA"
                      v-bind:optionB="statement[11].optionB"
                      v-bind:optionC="statement[11].optionC"
                      v-bind:optionD="statement[11].optionD"
                    />
                  </v-col>
                </v-row>
                <div v-if="question_h === 'ke1'">
                  <v-row no-gutters class="mt-3">
                    <v-col cols="12">
                      <StatementText
                        :text="statement[12].question"
                        :note="statement[12].commentApp"
                        :nr-notes="statement[12].nrNotes"
                        :noteA="statement[12].noteAppFormA"
                        :noteB="statement[12].noteAppFormB"
                        :noteC="statement[12].noteAppFormC"
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="mt-3">
                    <v-col cols="12">
                      <BaseValInput rules="required|max:150" v-model="question_i" v-bind:label="statement[12].label" />
                    </v-col>
                  </v-row>
                </div>
              </div>
              <v-divider class="mt-5 mb-5" />
              <v-row no-gutters>
                <v-col cols="12">
                  <h3 class="accent--text mb-5">Toelichting</h3>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <StatementText
                    :text="textData[4].text"
                    :note="textData[4].commentApp"
                    :nr-notes="textData[4].nrNotes"
                    :noteA="textData[4].noteAppFormA"
                    :noteB="textData[4].noteAppFormB"
                    :noteC="textData[4].noteAppFormC"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-3">
                <v-col cols="12">
                  <StatementText
                    :text="statement[13].question"
                    :note="statement[13].commentApp"
                    :nr-notes="statement[13].nrNotes"
                    :noteA="statement[13].noteAppFormA"
                    :noteB="statement[13].noteAppFormB"
                    :noteC="statement[13].noteAppFormC"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-3">
                <v-col cols="12">
                  <base-val-area rules="max:500" v-model="text_d" v-bind:label="statement[10].label" />
                </v-col>
              </v-row>
            </div>

            <v-col cols="12"> </v-col>
            <div class="text-end mr-15 mt-8 mb-15">
              <v-btn class="mr-5" color="secondary" @click="closeItem">{{ $t("crud.close") }}</v-btn>
              <v-btn color="primary" @click="handleSubmit(saveItem)" :disabled="invalid || !validate">Wijzig</v-btn>
            </div>
          </v-form>
        </ValidationObserver>
        <v-row></v-row>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Stat from "@/json/NpBV/moduleC.json";
import Text from "@/json/NpBV/textC.json";
import saving from "@/components/saving";
import nplanBvService from "@/services/nplan/NplanBvService";

export default {
  name: "module-a-edit",
  components: { ToolbarAuth, saving },
  data() {
    return {
      error: null,
      saving: false,
      statement: Stat,
      textData: Text,
      question_a: "",
      question_b: "",
      question_c: "",
      question_d: "",
      question_e: "",
      question_f: "",
      question_g: "",
      question_h: "",
      question_i: "",
      text_a: "",
      text_b: "",
      text_c: "",
      text_d: "",
    };
  },
  methods: {
    closeItem() {
      let ClientId = this.$route.params.id;
      this.$router.push({ name: "bvModules", params: { id: ClientId } });
    },
    saveItem() {
      this.saving = true;
      let clientId = this.$route.params.id;
      const payload = {
        question_a: this.question_a,
        question_b: this.question_b,
        question_c: this.question_c,
        question_d: this.question_d,
        question_e: this.question_e,
        question_f: this.question_f,
        question_g: this.question_g,
        question_h: this.question_h,
        question_i: this.question_i,
        text_a: this.text_a,
        text_b: this.text_b,
        text_c: this.text_c,
        text_d: this.text_d,
      };
      this.error = null;
      nplanBvService
        .updateModC(clientId, payload)
        .then(() => {
          this.saving = false;
          this.$router.push({ name: "bvModules", params: { id: clientId } });
        })
        .catch(() => {
          this.saving = false;
        });
    },
  },
  computed: {
    ...mapGetters("bvSingle", ["loading", "bv_planSingle"]),
  },
  mounted() {
    this.question_a = this.bv_planSingle.c_bv.question_a;
    this.question_b = this.bv_planSingle.c_bv.question_b;
    this.question_c = this.bv_planSingle.c_bv.question_c;
    this.question_d = this.bv_planSingle.c_bv.question_d;
    this.question_e = this.bv_planSingle.c_bv.question_e;
    this.question_f = this.bv_planSingle.c_bv.question_f;
    this.question_g = this.bv_planSingle.c_bv.question_g;
    this.question_h = this.bv_planSingle.c_bv.question_h;
    this.question_i = this.bv_planSingle.c_bv.question_i;
    this.text_a = this.bv_planSingle.c_bv.text_a;
    this.text_b = this.bv_planSingle.c_bv.text_b;
    this.text_c = this.bv_planSingle.c_bv.text_c;
    this.text_d = this.bv_planSingle.c_bv.text_d;
  },

  created() {},
};
</script>

<style scoped></style>
